
  <div class="con-app" style="display: inline !important;">
    <ng-container *ngIf="IsLoggedIn && isAuthorizedUser || IsLoggedIn && sharedDataService.isUserSalesConsultant">
      <con-app-notification-panel></con-app-notification-panel>
      <div class="con-app-nav-bar">
        <con-app-navbar [hidden]="hideNavBar" class="con-app-nav-bar" 
        *ngIf="IsLoggedIn"
        >
        </con-app-navbar>
        <ng-template #template>
          <ng-content></ng-content>
        </ng-template>
         
      </div> 
     </ng-container> 

      <div class="con-app-content">    
          <router-outlet></router-outlet>
      </div>
      <div class="modal clone-modal" style="padding-bottom: 10px; z-index: 500;"  *ngIf="sharedDataService.showPaymentSimulatorModal">
        <div class="clone-modal-contnet simulator-modal">
            <app-payment-simulator [masterData]="paymentSimulatorMasterData" [provider]="" (paymentSimulatorPdfEvent)="paymentSimulatorPdfGenerator($event)"></app-payment-simulator>
        </div>
    </div>
    <ng-template #simulatorPdfViewer>
      <p class="close-icon tmi tmi-close" style="position: relative;left: 96%;font-size: 24px; top: 28px; z-index: 200;" (click)="close()"></p>
      <ngx-extended-pdf-viewer [zoom]="'page-width'" [filenameForDownload]="paymentSimulatorPdfFilename"
      [base64Src]="paymentSimulatorPdfData" *ngIf="paymentSimulatorPdfData" useBrowserLocale="true" height="100vh" [backgroundColor]="transparent"
      [showPagingButtons]="true" [showDownloadButton]="true" [showBookmarkButton]="false"[showSecondaryToolbarButton]="true"
      [showPrintButton]="true" [showZoomButtons]="false"[showSidebarButton]="false" [showOpenFileButton]="false"
      [showRotateButton]=false [showScrollingButton]="false" [showSpreadButton]="false" (pdfDownloaded)="close()">
      </ngx-extended-pdf-viewer>
    </ng-template>
    <con-app-loader></con-app-loader>
</div>

  




